import { Logger } from "aws-amplify"
const logger = new Logger("$store/presence/getters") 

export default {
  // returns an array of vehicles that belong to the selected org
  orgVehicles: state => {
    if(!state.selectedOrg || !state.vehicles[state.selectedOrg]) {
      return []
    }

    return state.vehicles[state.selectedOrg]
  },

  devicesMap: state => {
    if(!state.selectedOrg || !state.devicesMapData[state.selectedOrg]) {
      return {}
    }

    return state.devicesMapData[state.selectedOrg]
  },

  vehicleStatus: state => {
    if(!state.selectedOrg || !state.vehicleStatusData[state.selectedOrg]) {
      return {}
    }

    return state.vehicleStatusData[state.selectedOrg]
  },


  // returns a set for the vehicles of the current org
  vehiclesSet: state => {
    if(!state.selectedOrg || !state.vehicles[state.selectedOrg]) {
      return {}
    }

    return state.vehicles[state.selectedOrg].reduce((set, item) => {
      set[item.id] = item
      return set
    }, {})
  },

  // returns map data for current org
  mapData: state => {
    if(!state.selectedOrg || !state.vehicles[state.selectedOrg] || !state.devicesMapData[state.selectedOrg]) {
      logger.debug("map data: no org of vehicles")
      return []
    }

    logger.debug("map Data", state, state.selectedOrg, state.vehicles[state.selectedOrg])

    const devices = Object.values(state.devicesMapData[state.selectedOrg])
    const currentStates = state.vehicles[state.selectedOrg].map(veh => {
      const vehicle_id = veh.id
      // we need to consider here how we decide which device to use, most recent last seen time seems most appropriate
      const options = devices.filter(d => d.vehicle_id == vehicle_id).sort((a, b) => b.data.mileage - a.data.mileage)
      const record = options.length ? options[0] : false

      return record
    })

    return currentStates.filter(i => i) // remove any vehicles without devices, we can't show these on the map view
  }
}